import { ResetUserPasswordRPCClientImpl } from "@pulse/pulse-rpcs/lib/profile/resetUserPasswordRPCClientImpl";
import { UpdateUsernameRPCClientImpl } from "@pulse/pulse-rpcs/lib/profile/updateUsernameRPCClientImpl";
import { MOCK } from "@pulse/shared-components";
import { APIClient } from "@surya-digital/tedwig";
import { MockUpdateUsernameRPCClientImpl } from "./MockUpdateUsernameRPCClient";
import { MockResetUserPasswordRPCClientImpl } from "./MockResetPasswordRPCClient";
import { UpdateUsernameRPC } from "@pulse/pulse-rpcs/lib/profile/updateUsernameRPC";
import { ResetUserPasswordRPC } from "@pulse/pulse-rpcs/lib/profile/resetUserPasswordRPC";

export const useUpdateUsernameRPCClient = (
  apiClient: APIClient,
): UpdateUsernameRPC => {
  if (MOCK.auditLogs) {
    return new MockUpdateUsernameRPCClientImpl();
  } else {
    return new UpdateUsernameRPCClientImpl(apiClient);
  }
};

export const useResetUserPasswordRPCClient = (
  apiClient: APIClient,
): ResetUserPasswordRPC => {
  if (MOCK.auditLogs) {
    return new MockResetUserPasswordRPCClientImpl();
  } else {
    return new ResetUserPasswordRPCClientImpl(apiClient);
  }
};
